//--------------------------------------------------------------------//
//******************** sipTrunksCtrl ***********************************//
//--------------------------------------------------------------------//
// Controller for the VOIP Telephony settings page. Fetches the trunk list on
// load, and provides the "Add Trunk" dialog (name only — the backend
// requires a non-empty host to create at all, so it's placeholdered with
// the name and the trunk is created disabled) followed immediately by the
// full-screen trunk detail popup (Trunk Info / Numbers / Short Code / SMS /
// Connected Apps tabs, see openTrunkDetail below) where the real host and everything else
// gets filled in. Clicking a trunk row later reopens the same detail popup.
// SMS used to be a sibling top-level tab (its own smsCtrl/table) before SMS
// became an embedded property of a trunk rather than its own resource - see
// sip-gudhub-server's docs/sip-trunks/sms.md.
import addSipTrunkDialogTemplateUrl from './add-sip-trunk-dialog.template.html';

angular.module('userSettingsMod')

.controller('sipTrunksCtrl', ['$scope', 'GhDialog', 'SipTrunksService', 'localizationService', '$templateCache', async function($scope, GhDialog, SipTrunksService, localizationService, $templateCache) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.sipTrunks = [];

  // Fetches all SIP trunks from the server and populates the list.
  $scope.getSipTrunks = async function() {
    try {
      $scope.sipTrunks = await SipTrunksService.getList();
      $scope.$evalAsync();
    } catch (error) {
      console.log(error);
    }
  };

  // Opens the full-screen trunk detail popup with Trunk Info and Numbers tabs.
  $scope.openTrunkDetail = function(trunk) {
    const outerScope = $scope;

    GhDialog.show({
      position: 'full',
      toolbar: false,
      template: {
        toolbar: '',
        content: `
          <div class="sip_trunk-popup">
              <div class="sip_trunk-popup__header">
                  <div class="sip_trunk-name-wrapper">
                      <div class="sip_trunk_name_input">{{trunk.name}}</div>
                  </div>

                  <div class="sip_trunk-status-wrapper">
                      <span class="status-badge" ng-class="trunk.enabled ? 'running' : 'stopped'">
                          {{trunk.enabled ? translate('Enabled') : translate('Disabled')}}
                      </span>
                  </div>

                  <span
                      class="close_dialog"
                      ng-click="cancel()"
                      gh-icon="cross #0D99FF 30px"
                  ></span>
              </div>

              <div class="sip_trunk-popup__nav-panes">
              <div class="sip_trunk-popup__nav-track" ng-class="{'--detail_open': tabDetailOpen}">
              <div class="sip_trunk-popup__tabs">
                  <div class="sip_trunk-popup__tab"
                       ng-class="{'sip_trunk-popup__tab--active': activeTab === 'info'}"
                       ng-click="activeTab = 'info'; tabDetailOpen = true;">
                      {{translate('Trunk Info')}}
                      <span class="sip_trunk-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
                  <div class="sip_trunk-popup__tab"
                       ng-class="{'sip_trunk-popup__tab--active': activeTab === 'numbers'}"
                       ng-click="activeTab = 'numbers'; tabDetailOpen = true;">
                      {{translate('Numbers')}}
                      <span class="sip_trunk-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
                  <div class="sip_trunk-popup__tab"
                       ng-class="{'sip_trunk-popup__tab--active': activeTab === 'shortCode'}"
                       ng-click="activeTab = 'shortCode'; tabDetailOpen = true;">
                      {{translate('Short Code')}}
                      <span class="sip_trunk-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
                  <div class="sip_trunk-popup__tab"
                       ng-class="{'sip_trunk-popup__tab--active': activeTab === 'sms'}"
                       ng-click="activeTab = 'sms'; tabDetailOpen = true;">
                      {{translate('SMS')}}
                      <span class="sip_trunk-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
                  <div class="sip_trunk-popup__tab"
                       ng-class="{'sip_trunk-popup__tab--active': activeTab === 'connectedApps'}"
                       ng-click="activeTab = 'connectedApps'; tabDetailOpen = true;">
                      {{translate('Connected Apps')}}
                      <span class="sip_trunk-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
                  <div class="sip_trunk-popup__tab"
                       ng-class="{'sip_trunk-popup__tab--active': activeTab === 'debug'}"
                       ng-click="activeTab = 'debug'; tabDetailOpen = true;">
                      {{translate('Debug')}}
                      <span class="sip_trunk-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                  </div>
              </div>

              <div class="sip_trunk-popup__content-pane">
              <div class="sip_trunk-popup__mobile-header">
                  <span class="sip_trunk-popup__mobile-back" ng-click="tabDetailOpen = false">
                      <span gh-icon="arrow_left 0893d2 24px normal"></span>
                  </span>
                  <span ng-if="activeTab === 'info'">{{translate('Trunk Info')}}</span>
                  <span ng-if="activeTab === 'numbers'">{{translate('Numbers')}}</span>
                  <span ng-if="activeTab === 'shortCode'">{{translate('Short Code')}}</span>
                  <span ng-if="activeTab === 'sms'">{{translate('SMS')}}</span>
                  <span ng-if="activeTab === 'connectedApps'">{{translate('Connected Apps')}}</span>
                  <span ng-if="activeTab === 'debug'">{{translate('Debug')}}</span>
              </div>
              <div class="sip_trunk-popup__content">
                  <div class="trunk-info" ng-show="activeTab === 'info'">
                      <trunk-info-tab trunk="trunk" on-update="onTrunkUpdate()"></trunk-info-tab>
                  </div>

                  <div class="trunk-numbers-wrapper" ng-show="activeTab === 'numbers'">
                      <trunk-numbers-tab trunk="trunk" on-update="onTrunkUpdate()"></trunk-numbers-tab>
                  </div>

                  <div class="trunk-info" ng-show="activeTab === 'shortCode'">
                      <trunk-short-code-tab trunk="trunk" on-update="onTrunkUpdate()"></trunk-short-code-tab>
                  </div>

                  <div class="trunk-info" ng-show="activeTab === 'sms'">
                      <trunk-sms-tab trunk="trunk" on-update="onTrunkUpdate()"></trunk-sms-tab>
                  </div>

                  <div class="trunk-numbers-wrapper" ng-show="activeTab === 'connectedApps'">
                      <trunk-connected-apps-tab trunk="trunk" on-update="onTrunkUpdate()"></trunk-connected-apps-tab>
                  </div>

                  <div class="trunk-info" ng-show="activeTab === 'debug'">
                      <trunk-debug-tab trunk="trunk" on-update="onTrunkUpdate()"></trunk-debug-tab>
                  </div>
              </div>
              </div>
              </div>
              </div>
          </div>
        `
      },
      locals: {
        trunk
      },
      controller: ['$scope', 'trunk', 'localizationService', function($scope, trunk, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.trunk = trunk;
        $scope.activeTab = 'info';
        $scope.tabDetailOpen = false;

        $scope.onTrunkUpdate = function() {
          outerScope.$applyAsync();
        };
      }]
    });
  };

  // Opens the "Add Trunk" dialog — just a name. On success, immediately
  // opens the trunk detail popup so the user can fill in the host, etc.
  $scope.showDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        sipTrunks: $scope.sipTrunks,
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: $templateCache.get(addSipTrunkDialogTemplateUrl)
      },
      controller: ['$scope', 'sipTrunks', 'safeApply', 'SipTrunksService', 'localizationService', function($scope, sipTrunks, safeApply, SipTrunksService, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';
        $scope.trunk = { name: '' };
        $scope.smsProvider = 'twilio';
        $scope.isCreating = false;

        $scope.addTrunk = async function() {
          const name = ($scope.trunk.name || '').trim();
          if (!name) {
            $scope.errMessage = 'Please, type trunk name';
            return;
          }

          $scope.isCreating = true;

          try {
            // host is required server-side to create a trunk at all —
            // placeholder it with the name and leave the trunk disabled
            // (skips writing the FreeSWITCH gateway file) until the real
            // host is set via the Trunk Info tab. provider is a plain
            // top-level field, so the chosen SMS provider is set right here
            // rather than needing a follow-up save.
            //
            // Binotel is the one exception: it always routes through the
            // same Ukrainian-IP FreeSWITCH relay (see
            // sip-gudhub-server/docs/sip-trunks/binotel-relay.md), a known,
            // fixed value - so there's nothing to fill in manually
            // afterward. register: false since the relay does the real
            // registration with Binotel, not this app's own FreeSWITCH.
            const isBinotel = $scope.smsProvider === 'binotel';
            const created = await SipTrunksService.create({
              name,
              host: isBinotel ? '173.242.60.18:5080' : name,
              enabled: false,
              provider: $scope.smsProvider,
              ...(isBinotel ? { register: false } : {})
            });

            sipTrunks.push(created);
            safeApply();
            $scope.hide(created);
          } catch (error) {
            console.log(error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.isCreating = false;
            $scope.$evalAsync();
          }
        };
      }]
    }).then(function(created) {
      if (created) {
        $scope.openTrunkDetail(created);
      }
    });
  };

  await $scope.getSipTrunks();

}]);
